import Order from './class.order';
import Cookies from 'js-cookie';
import Confirm from 'jquery-confirm';


window.addEventListener('load', event => {
    customQtyInput();
    init();
});

function init() {

    // remove cookie order if is necessary
    if ($('body').hasClass('is-front')) {
        Cookies.remove('order');
        Cookies.remove('total_prot');
        Cookies.remove('total_cal');
        Cookies.remove('total_cno');
        Cookies.remove('nbCnoPrescrit');
        localStorage.removeItem('orderDetailProcessed');
        sessionStorage.removeItem('purchaseEventSent');
    }

    var inputValues = [];
    let order = new Order();
    var maxProt = order.getNbDay() * order.getProtMax();
    var maxCal = order.getNbDay() * order.getCalMax();
    /*Remplissage de panier initial*/
    if (window.location.pathname === '/detail-commande/' && !localStorage.getItem('orderDetailProcessed')) {
        $('.validation-banner').removeClass('hidden');
        $('.order-detail__row').each(function() {
            var inputValue = $(this).find('.custom-input-number').val();
            var parsed = parseInt(inputValue)-1;

            var postID = $(this).find('.custom-input-number').attr('data-postID');
            var prot = $(this).find('.custom-input-number').attr('data-proteine');
            var cal = $(this).find('.custom-input-number').attr('data-calorie');
            var cno = $(this).find('.custom-input-number').attr('data-cno');

            var valuecno = parseFloat($('.total-cno').text());

            for (var i = 0; i < parsed; i++) {
                order.addProduct(postID, prot, cal, cno, 1);
                if (valuecno > order.getNbCnoPrescrit() * 3) {
                    $('.validation-banner').addClass('hidden');
                }
            }
        });
        localStorage.setItem('orderDetailProcessed', 'true');
    }
    /*Si jamais on fait du retour arrière.*/
    else if (window.location.pathname === '/detail-commande/' && localStorage.getItem('orderDetailProcessed')) {
        var currentMinProt = order.getNbDay()*order.getProtMin();
        var currentMinCal = order.getNbDay()*order.getCalMin();
        $('.order-detail__row').each(function() {
            var postID = $(this).find('.custom-input-number').attr('data-postID');
            var prot = $(this).find('.custom-input-number').attr('data-proteine');
            var cal = $(this).find('.custom-input-number').attr('data-calorie');
            var cno = $(this).find('.custom-input-number').attr('data-cno');

            // Apport réel par pack (les valeurs sont par portion → * cno)
            var num = function(v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? 0 : n; };
            var protPerPack = num(prot) * num(cno);
            var calPerPack = num(cal) * num(cno);

            while (currentMinProt > order.getProteine() || currentMinCal > order.getCalorie()) {
                var needProt = currentMinProt > order.getProteine();
                var needCal = currentMinCal > order.getCalorie();
                // Ce produit peut-il encore combler un déficit ? Sinon on arrête (évite la boucle infinie
                // sur un produit sans calories/protéines ou à cno = 0).
                var helps = (needProt && protPerPack > 0) || (needCal && calPerPack > 0);
                if (!helps) break;
                order.addProduct(postID, prot, cal, cno, 1);
            }
            $('.total-calorie').text(Math.round(order.getCalorie()));
            $('.total-proteine').text(Math.round(order.getProteine()));
        });

    }

    Cookies.set('order', JSON.stringify(order));

    if (window.location.pathname === '/detail-commande/') {
        updateTotalsDisplay();
    }

    if (window.location.pathname === '/ma-delivrance/') {
        pushPurchaseEvent();
    }

    let tooltip = $('.go-to-order .tooltip');
    let goToOrderBtn = $('.go-to-order');
    let dayInput = $('.choixjour .quantity .custom-input-number');
    let nbProduct = order.getNbProduct();
    let nbDay = order.getNbDay();
    let inputJson = $('input.json');
    updateTooltip(0, nbProduct);

    dayInput.val(nbDay);
    if (nbProduct > 0) {
        goToOrderBtn.removeClass('disabled');
        goToOrderBtn.removeAttr('disabled');
    }

    // Initialiser le radio CNO depuis le cookie si on revient en arrière
    var cnoRadios = $('input[name="nb_cno_prescrit"]');
    if (cnoRadios.length > 0) {
        // Sauvegarder immédiatement au changement de radio
        cnoRadios.on('change', function() {
            var order = new Order();
            order.setNbCnoPrescrit($(this).val());
        });
    }

    // Validation du formulaire CNO au submit du formulaire filtre
    var formCno = document.getElementById('form-choix-cno');
    if (formCno) {
        var errorMessage = formCno.dataset.errorMessage;
        var cnoRadios = formCno.querySelectorAll('input[name="nb_cno_prescrit"]');
        cnoRadios.forEach(function(radio) {
            radio.setCustomValidity(errorMessage);
            radio.addEventListener('change', function() {
                cnoRadios.forEach(function(r) { r.setCustomValidity(''); });
            });
        });
    }

    $('#form-filtre-custom').on('submit', function(e) {
        if (formCno && !formCno.reportValidity()) {
            e.preventDefault();
            return false;
        }
        var order = new Order();
        var nbDayInput = $('.choixjour .quantity input[type="number"]');
        if (nbDayInput.length > 0) {
            order.setNbDay(nbDayInput.val());
        }
        var selectedCno = $('input[name="nb_cno_prescrit"]:checked');
        if (selectedCno.length > 0) {
            order.setNbCnoPrescrit(selectedCno.val());
        }
    });

    $(".order-next").on('click', function(e) {
        var order = new Order();
        var nbDayNextInput = $('.choixjour .quantity input[type="number"]');
        if (nbDayNextInput.length > 0) {
            order.setNbDay(nbDayNextInput.val());
        }
        var selectedCno = $('input[name="nb_cno_prescrit"]:checked');
        if (selectedCno.length > 0) {
            order.setNbCnoPrescrit(selectedCno.val());
        }
    });

    $(".app-navigation a").on('click', function(e) {
        if ($(this).hasClass('disabled')) {
            e.preventDefault();
            var overlay = $(
                '<div class="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center order-warning-overlay">' +
                    '<div class="bg-white rounded-lg p-8 max-w-[420px] w-[90%] relative text-center">' +
                        '<button class="order-warning-close absolute top-3 right-3 bg-transparent border-none text-2xl cursor-pointer leading-none text-gray-700">&times;</button>' +
                        '<p class="text-secondary-dark font-fontsemibold text-lg m-0">Nous vous invitons à ajouter des produits à votre sélection</p>' +
                    '</div>' +
                '</div>'
            );
            $('body').append(overlay);
            overlay.on('click', function(e) {
                if ($(e.target).hasClass('order-warning-overlay') || $(e.target).hasClass('order-warning-close')) {
                    overlay.remove();
                }
            });
        }
    });

    $('.add-to-cart__button').change(function (){
        var postID = $(this).attr('data-postID');
        var qty = $('.quantity_'+postID).val();
        var prot = $(this).attr('data-proteine');
        var cal = $(this).attr('data-calorie');
        var cno = $(this).attr('data-cno');
        var order = new Order();
        if(this.checked){
            // On n'applique plus de plafond ici : la page Sélectionner ne fait que
            // choisir les produits (l'ajustement gère ensuite les quantités/seuils).
            // Sinon, avec les totaux en x cno, la sélection se bloquait vers 13 produits.
            order.addProduct(postID, prot, cal, cno, qty);
        }else {
            console.log('on retire tous');
            while(order.products.some(p => p.postID === postID)) {
                order.removeProduct(postID, 1);
            }
            console.log(order)
        }
        updateTooltip();
        updateTotalsDisplay(false);
    });

    $('.product-quatity .quantity-up').on('click', function() {
        var el = $(this).parents('.quantity').first();
        var postID = el.find('.custom-input-number').attr('data-postID');
        var prot = el.find('.custom-input-number').attr('data-proteine');
        var cal = el.find('.custom-input-number').attr('data-calorie');
        var cno = el.find('.custom-input-number').attr('data-cno');
        var uniteDigit = parseInt(el.find('.custom-input-number').attr('data-unite-digit'), 10) || 0;
        var currentQty = el.find('.custom-input-number').val();
        var qty = 1;
        var order = new Order();
        order.addProduct(postID, prot, cal, cno, qty);
        updateTooltip();
        updateTotalsDisplay();
        var pack_a_edit = currentQty * uniteDigit;
        el.closest('.order-detail__row').find('.custom-quantite').html('<strong>' + pack_a_edit + '</strong>');
    })

    $('.product-quatity .quantity-down').on('click', function() {
        var el = $(this).parents('.quantity').first();
        var parentEl = $(this).parents('.order-detail__row').first();
        var postID = el.find('.custom-input-number').attr('data-postID');
        var prot = el.find('.custom-input-number').attr('data-proteine');
        var cal = el.find('.custom-input-number').attr('data-calorie');
        var cno = el.find('.custom-input-number').attr('data-cno');
        var uniteDigit = parseInt(el.find('.custom-input-number').attr('data-unite-digit'), 10) || 0;
        var currentQty = el.find('.custom-input-number').val();

        var qty = -1;
        var order = new Order();

        if (currentQty == "0") {
            $.confirm({
                title: 'Êtes-vous sûr de vouloir supprimer ce produit de votre délivrance ?',
                content: '',
                // closeIcon: true,
                buttons: {
                    ok: {
                        text: "Supprimer",
                        btnClass: 'btn btn-grey-light --block mb-6',
                        keys: ['enter'],
                        action: function(){
                            order.removeProduct(postID);
                            updateTooltip(qty);
                            parentEl.remove();
                            updateTotalsDisplay();
                        }
                    },
                    cancel: {
                        text: "Annuler",
                        btnClass: 'btn btn-secondary  --block',
                        keys: ['enter'],
                        action: function(){
                            el.find('.custom-input-number').val(1);
                            var pack_a_edit = 1 * uniteDigit;
                            el.closest('.order-detail__row').find('.custom-quantite').html('<strong>' + pack_a_edit + '</strong>');
                        }
                    }
                }
            });
        } else {
            order.removeProduct(postID);
            updateTooltip(qty);
            updateTotalsDisplay();
            var pack_a_edit = currentQty * uniteDigit;
            el.closest('.order-detail__row').find('.custom-quantite').html('<strong>' + pack_a_edit + '</strong>');
        }
    })
    //console.log(order);
    const postIDCounts = order.products.reduce((acc, product) => {
        acc[product.postID] = (acc[product.postID] || 0) + 1;
        return acc;
    }, {});
    document.querySelectorAll('input[data-postID]').forEach(input => {
        const postID = input.getAttribute('data-postID');
        if (postIDCounts[postID] !== undefined) {
            input.value = postIDCounts[postID];
        }
    });
    console.log(order);
    if (window.location.pathname.includes('/produit/')  && localStorage.getItem('orderDetailProcessed')) {
        if (order && order.products) {
            // Récupère les produits uniques avec leurs données nutritionnelles
            var uniqueProducts = {};
            order.products.forEach(function(p) {
                if (!uniqueProducts[p.postID]) {
                    uniqueProducts[p.postID] = p;
                }
            });

            // Remet l'order à plat : 1 unité par produit sélectionné
            order.products = [];
            order.nbProduct = 0;
            Object.keys(uniqueProducts).forEach(function(postID) {
                var p = uniqueProducts[postID];
                order.products.push({
                    postID: p.postID,
                    qty: 1,
                    proteine: p.proteine,
                    calorie: p.calorie,
                    cno: p.cno
                });
                order.nbProduct++;
            });
            order.save();

            // Coche les checkboxes correspondantes
            var postIDs = new Set(Object.keys(uniqueProducts));
            document.querySelectorAll('.custom_checkbox').forEach(function(input) {
                var postIdAttr = input.getAttribute('data-postid');
                if (postIDs.has(postIdAttr)) {
                    input.checked = true;
                }
            });
        }
        localStorage.removeItem('orderDetailProcessed');
    }
}

function updateTotalsDisplay(editTotal = true) {
    var order = new Order();
    var totalProt = order.getProteine();
    var totalCal = order.getCalorie();
    var totalCno = order.getCno();
    var minProt = order.getNbDay() * order.getProtMin();
    var maxProt = order.getNbDay() * order.getProtMax();
    var minCal = order.getNbDay() * order.getCalMin();
    var maxCal = order.getNbDay() * order.getCalMax();
    var protOK = true;
    var calOK = true;
    var cnoOk = true;
    const messages = [];
    
    if (editTotal) {
        $('.total-proteine').text(Math.round(totalProt));
        $('.total-calorie').text(Math.round(totalCal));
        $('.total-cno').text(totalCno);
    }

    var protExcess = false;
    var calExcess = false;
    if (totalProt < minProt) {
        protOK = false;
        // message += " Protéines insuffisantes ";
    }
    if (totalProt > maxProt) {
        protOK = false;
        protExcess = true;
        // message += " Protéines en excès ";
    }
    if (totalCal < minCal) {
        calOK = false;
        // message += " Calories insuffisantes ";
    }
    if (totalCal > maxCal) {
        calOK = false;
        calExcess = true;
        // message += " Calories en excès ";
    }

    var nbCnoPrescrit = order.getNbCnoPrescrit();
    var cnoMax = nbCnoPrescrit * 3;
    // if(totalCno > cnoMax) {
    //     cnoOk = false;
    // }

    // Délivrance validée dès qu'au moins une des deux conditions (protéines ou calories) est remplie.
    var validated = protOK || calOK;

    if (protExcess || calExcess) {
        // Trop de protéines/calories : on invite à réduire, pas à diversifier.
        messages.push("Nous vous invitons à baisser la quantité de produits");
    } else if (!protOK || !calOK) {
        messages.push("Nous vous invitons à ajouter des produits à votre sélection pour diversifier la délivrance");
    }


    if (editTotal) {
        if ($('.min-proteine').length > 0 && $('.max-proteine').length > 0 && $('.min-calorie').length > 0 && $('.max-calorie').length > 0) {
            $('.min-proteine').text(minProt);
            $('.max-proteine').text(maxProt);
            $('.min-calorie').text(minCal);
            $('.max-calorie').text(maxCal);
        }
    }

    if (editTotal) {
        // Flag piloté côté PHP (SO_BLOCK_NEXT_IF_INSUFFICIENT) : si activé, on rebloque
        // le passage à l'étape suivante tant que les seuils ne sont pas atteints.
        var blockNext = !!(window.soData && window.soData.blockNextIfInsufficient);
        if (!validated || !cnoOk) {
            $('.order_detail__message').html(messages.join('<br>'));
            $('.validation-banner').addClass('hidden');
            if (blockNext) {
                disableValidateBtn();
            } else {
                enableValidateBtn();
            }
        } else {
            $('.order_detail__message').html("");
            $('.validation-banner').removeClass('hidden');
            enableValidateBtn();
        }
    }
    // Délivrance validée : la condition non remplie passe en noir (neutral) au lieu de rouge (nok).
    var notOkClass = (editTotal && validated) ? 'neutral' : 'nok';
    if (!protOK) {
        $('.total-proteine').parent().removeClass('ok nok neutral');
        $('.total-proteine').parent().addClass(notOkClass);
    } else {
        $('.total-proteine').parent().removeClass('nok neutral');
        $('.total-proteine').parent().addClass('ok');
    }
    if (!calOK) {
        $('.total-calorie').parent().removeClass('ok nok neutral');
        $('.total-calorie').parent().addClass(notOkClass);
    } else {
        $('.total-calorie').parent().removeClass('nok neutral');
        $('.total-calorie').parent().addClass('ok');
    }
    if( !cnoOk) {
        $('.total-cno').parent().removeClass('ok');
        $('.total-cno').parent().addClass('nok');
    }else {
        $('.total-cno').parent().removeClass('nok');
        $('.total-cno').parent().addClass('ok');
    }
}

function enableValidateBtn() {
    $('.order-next').removeClass('disabled');
    $('.order-next').removeAttr('disabled');
    $('.order-next').attr('href', '/ma-delivrance/');
}
function disableValidateBtn() {
    $('.order-next').addClass('disabled');
    $('.validation-banner').addClass('hidden');
    $('.order-next').attr('disabled', true);
    $('.order-next').attr('href', '#');
}

function updateTooltip(qty = 1, forceNbProduct = 0) {
    let tooltip = $('.go-to-order .tooltip');
    let goToOrderBtn = $('.go-to-order');
    var nbProduct = 0;
    if (tooltip.text() != "") {
        nbProduct = parseInt(tooltip.text());
    }

    if (forceNbProduct != 0) {
        nbProduct = forceNbProduct;
    }
    nbProduct = nbProduct + qty;
    if (nbProduct >= 10) {
        tooltip.addClass('text-sm');
    }
    tooltip.text(nbProduct);
    if (nbProduct > 0) {
        goToOrderBtn.removeClass('disabled');
        goToOrderBtn.removeAttr('disabled');
    }
}

function customQtyInput() {
    // custom quantity input

    $('.quantity input').wrap("<div class='quantity-nav'></div>");
    $('<div class="quantity-button quantity-up">+</div>').insertAfter('.quantity input');
    $('<div class="quantity-button quantity-down">-</div>').insertBefore('.quantity input');
    $('.quantity').each(function() {
        var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');

        btnUp.on('click', function() {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

        btnDown.on('click', function() {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

    });
}

function pushPurchaseEvent() {
    var items = [];
    document.querySelectorAll('.order-detail__row[data-post-id]').forEach(function(row) {
        items.push({
            item_id: row.dataset.postId,
            item_name: row.dataset.productName,
            quantity: parseInt(row.dataset.quantity),
            price: 0
        });
    });

    if (!items.length) return;
    if (sessionStorage.getItem('purchaseEventSent')) return;
    sessionStorage.setItem('purchaseEventSent', 'true');

    var gaClientId = '';
    var gaCookie = document.cookie.split('; ').find(function(c) { return c.startsWith('_ga='); });
    if (gaCookie) {
        var parts = gaCookie.split('=')[1].split('.');
        gaClientId = parts.slice(2).join('.');
    }

    var now = new Date();
    var datePart = now.getFullYear().toString() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0');
    var timePart = String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0');
    var transactionId = 'CMD' + datePart + '-' + timePart;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'purchase',
        client_id: gaClientId,
        ecommerce: {
            transaction_id: transactionId,
            currency: 'EUR',
            value: 0,
            items: items
        }
    });
}